export const ORDER_CLEAR_STORE = "ORDER_CLEAR_STORE";

export const ORDER_DETAIL_LOAD_START = "ORDER_DETAIL_LOAD_START";
export const ORDER_DETAIL_LOAD_SUCCESS = "ORDER_DETAIL_LOAD_SUCCESS";
export const ORDER_DETAIL_LOAD_FAIL = "ORDER_DETAIL_LOAD_FAIL";

export const ORDER_EDIT_LOAD_START = "ORDER_EDIT_LOAD_START";
export const ORDER_EDIT_LOAD_SUCCESS = "ORDER_EDIT_LOAD_SUCCESS";
export const ORDER_EDIT_LOAD_FAIL = "ORDER_EDIT_LOAD_FAIL";

export const ORDER_EDIT_SAVE_START = "ORDER_EDIT_SAVE_START";
export const ORDER_EDIT_SAVE_SUCCESS = "ORDER_EDIT_SAVE_SUCCESS";
export const ORDER_EDIT_SAVE_FAIL = "ORDER_EDIT_SAVE_FAIL";

export const ORDER_CUSTOMER_INFO_LOAD_START = "ORDER_CUSTOMER_INFO_LOAD_START";
export const ORDER_CUSTOMER_INFO_LOAD_SUCCESS = "ORDER_CUSTOMER_INFO_LOAD_SUCCESS";
export const ORDER_CUSTOMER_INFO_LOAD_FAIL = "ORDER_CUSTOMER_INFO_LOAD_FAIL";

export const ORDER_NEW_SAVE_START = "ORDER_NEW_SAVE_START";
export const ORDER_NEW_SAVE_SUCCESS = "ORDER_NEW_SAVE_SUCCESS";
export const ORDER_NEW_SAVE_FAIL = "ORDER_NEW_SAVE_FAIL";

export const ORDER_CHANGE_STATUS_START = "ORDER_CHANGE_STATUS_START";
export const ORDER_CHANGE_STATUS_SUCCESS = "ORDER_CHANGE_STATUS_SUCCESS";
export const ORDER_CHANGE_STATUS_FAIL = "ORDER_CHANGE_STATUS_FAIL";

export const ORDER_PAYMENT_LOAD_START = "ORDER_PAYMENT_LOAD_START";
export const ORDER_PAYMENT_LOAD_SUCCESS = "ORDER_PAYMENT_LOAD_SUCCESS";
export const ORDER_PAYMENT_LOAD_FAIL = "ORDER_PAYMENT_LOAD_FAIL";

export const ORDER_LIST_LOAD_START = "ORDER_LIST_LOAD_START";
export const ORDER_LIST_LOAD_SUCCESS = "ORDER_LIST_LOAD_SUCCESS";
export const ORDER_LIST_LOAD_FAIL = "ORDER_LIST_LOAD_FAIL";

export const ORDER_LIST_SUMMURY_LOAD_START = "ORDER_LIST_SUMMURY_LOAD_START";
export const ORDER_LIST_SUMMURY_LOAD_SUCCESS = "ORDER_LIST_SUMMURY_LOAD_SUCCESS";
export const ORDER_LIST_SUMMURY_LOAD_FAIL = "ORDER_LIST_SUMMURY_LOAD_FAIL";

export const ORDER_LIST_MEDIUM_SUMMURY_LOAD_START = "ORDER_LIST_MEDIUM_SUMMURY_LOAD_START";
export const ORDER_LIST_MEDIUM_SUMMURY_LOAD_SUCCESS = "ORDER_LIST_MEDIUM_SUMMURY_LOAD_SUCCESS";
export const ORDER_LIST_MEDIUM_SUMMURY_LOAD_FAIL = "ORDER_LIST_MEDIUM_SUMMURY_LOAD_FAIL";

export const CATEGORY_LIST_LOAD_START = "CATEGORY_LIST_LOAD_START";
export const CATEGORY_LIST_LOAD_SUCCESS = "CATEGORY_LIST_LOAD_SUCCESS";
export const CATEGORY_LIST_LOAD_FAIL = "CATEGORY_LIST_LOAD_FAIL";

export const ITEM_LIST_LOAD_START = "ITEM_LIST_LOAD_START";
export const ITEM_LIST_LOAD_SUCCESS = "ITEM_LIST_LOAD_SUCCESS";
export const ITEM_LIST_LOAD_FAIL = "ITEM_LIST_LOAD_FAIL";

export const ORDER_STATUS_LIST_LOAD_START = "ORDER_STATUS_LIST_LOAD_START";
export const ORDER_STATUS_LIST_LOAD_SUCCESS = "ORDER_STATUS_LIST_LOAD_SUCCESS";
export const ORDER_STATUS_LIST_LOAD_FAIL = "ORDER_STATUS_LIST_LOAD_FAIL";

export const TAG_LIST_LOAD_START = "TAG_LIST_LOAD_START";
export const TAG_LIST_LOAD_SUCCESS = "TAG_LIST_LOAD_SUCCESS";
export const TAG_LIST_LOAD_FAIL = "TAG_LIST_LOAD_FAIL";

export const DISCOUNT_LIST_LOAD_START = "DISCOUNT_LIST_LOAD_START";
export const DISCOUNT_LIST_LOAD_SUCCESS = "DISCOUNT_LIST_LOAD_SUCCESS";
export const DISCOUNT_LIST_LOAD_FAIL = "DISCOUNT_LIST_LOAD_FAIL";

export const ITEM_HISTORY_LOAD_START = "ITEM_HISTORY_LOAD_START";
export const ITEM_HISTORY_LOAD_SUCCESS = "ITEM_HISTORY_LOAD_SUCCESS";
export const ITEM_HISTORY_LOAD_FAIL = "ITEM_HISTORY_LOAD_FAIL";

export const itemPrimeCostLoadStart = "ORDER_ITEM_PRIMECOST_LOAD_START";
export const itemPrimeCostLoadSuccess = "ORDER_ITEM_PRIMECOST_LOAD_SUCCESS";
export const itemPrimeCostLoadFail = "ORDER_ITEM_PRIMECOST_LOAD_FAIL";

export const itemSaveInvoiceStart = "ORDER_INVOICING_START";
export const itemSaveInvoiceSuccess = "ORDER_INVOICING_SUCCESS";
export const itemSaveInvoiceFail = "ORDER_INVOICING_FAIL";

export const itemCheckInvoiceStart = "ORDER_CHECK_INVOICING_START";
export const itemCheckInvoiceSuccess = "ORDER_CHECK_INVOICING_SUCCESS";
export const itemCheckInvoiceFail = "ORDER_CHECK_INVOICING_FAIL";
